import './SharedChartInteractions.css';
export var containerSVG = '_14qoaxs0-3-15-1';